module.exports = __webpack_public_path__ + "static/media/hizaNobashi.66974e36.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/locomo/hizaNobashi.png
// module id = 1703
// module chunks = 1